import { useCookie, computed } from "#imports";

export default function useDebugMode () {
  const debugCookie = useCookie<boolean>( "apollo-debug" );

  const debugQuery = computed( () => {
    if ( import.meta.client ) {
      const queryParams = new URLSearchParams( window.location.search );
      return queryParams.get( "apolloDebug" ) === "true";
    }

    return false;
  } );

  const enabled = computed( () => {
    return debugQuery.value || debugCookie.value;
  } );

  function toggle () {
    debugCookie.value = !debugCookie.value;
  }

  return {
    toggle,
    enabled,
  };
}
